var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"id":"img","src":_vm.currentDocumento.documento + _vm.stgAccessKey,"alt":""}})])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }